export default "__VITE_ASSET__CfBRjyKJ__"